import { createFileRoute } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import { Badge } from "@/client/components/shad/badge";
import {
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSet,
} from "@/client/components/shad/field";

export const Route = createFileRoute("/(protected)/settings/skopa/view")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Skopa</BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>View</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <form>
            <FieldSet>
              <FieldLegend>Skopa View</FieldLegend>
              <FieldDescription>
                Set the view of the Skopa map. Here you can control if the map
                is to follow one platform or multiple.
              </FieldDescription>
              <FieldGroup>Form elements</FieldGroup>
            </FieldSet>
          </form>
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>
                  Skopa status{" "}
                  <Badge className="bg-lime-50 text-lime-700 dark:bg-lime-950 dark:text-lime-300">
                    Active
                  </Badge>
                </CardTitle>
                <CardDescription>
                  Descripting for the current status of Skopa
                </CardDescription>
              </CardHeader>
              <CardContent>Status content</CardContent>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
